import React from 'react';
const tomes = [{
  number: '01',
  title: 'El Filtro — Fundamentos y Sistemas',
  desc: 'Introducción al lenguaje académico, historia crítica de la psicología, estructuralismo, funcionalismo y conductismo.'
}, {
  number: '02',
  title: 'El Cuerpo — Neurociencias y Biología',
  desc: 'Neurona, sinapsis, SNC y SNP, lóbulos cerebrales, atención, memoria, emoción y motivación.'
}, {
  number: '03',
  title: 'El Inconsciente — Psicoanálisis y Escuelas',
  desc: 'Primera y segunda tópica, metapsicología, complejo de Edipo, introducción a Lacan y escuelas psicológicas.'
}, {
  number: '04',
  title: 'El Desarrollo — Evolutiva y Vínculos',
  desc: 'Desarrollo infantil y adolescente, Piaget, Vigotsky, Winnicott y psicología del ciclo vital.'
}, {
  number: '05',
  title: 'La Clínica — Psicopatología y Evaluación',
  desc: 'Clasificación de trastornos, criterios diagnósticos, evaluación psicológica y ética profesional.'
}, {
  number: '06',
  title: 'El Sistema Social — Grupos y Contexto',
  desc: 'Psicología social, dinámica grupal, psicología laboral, comunitaria y metodología de investigación.'
}];
const includes = ['Esquemas y cuadros comparativos listos para estudiar', 'Guías de estudio con lo esencial para cada parcial', 'Simulacros de examen y preguntas frecuentes por materia', 'Resúmenes, mnemotecnias y autoevaluación por unidad'];
export function WhatYouGet() {
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-8" style={{
    background: 'linear-gradient(180deg, #FDF4E7 0%, #FEFAF4 50%, #FEFAF4 100%)'
  }} data-id="element-392">
      <div className="mx-auto max-w-4xl" data-id="element-393">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center m-0 mb-1" style={{
        color: '#1E1208'
      }} data-id="element-394">
          Lo que{' '}
          <span style={{
          color: '#C8922A'
        }} data-id="element-395">recibís</span>
        </h2>
        <p className="text-center text-sm m-0 mb-6" style={{
        color: '#9A7B5A'
      }} data-id="element-396">
          6 tomos · +360 páginas · Toda la carrera organizada
        </p>

        {/* Tomos */}
        <div className="rounded-xl overflow-hidden shadow-sm mb-4" style={{
        border: '1px solid rgba(200,146,42,0.22)'
      }} data-id="element-397">
          {/* Header */}
          <div className="px-5 py-2.5" style={{
          background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 50%, #7A9E7E 100%)'
        }} data-id="element-398">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-399">
              📚 LOS 6 TOMOS — Toda la carrera en un solo lugar
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y" style={{
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: 'rgba(200,146,42,0.10)'
        }} data-id="element-400">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-2.5" style={{
            borderColor: 'rgba(200,146,42,0.10)'
          }} data-id="element-401">
                <span className="shrink-0 text-lg font-black w-8 text-center" style={{
              color: 'rgba(200,146,42,0.35)'
            }} data-id="element-402">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-403">
                  <span className="block text-sm font-black" style={{
                color: '#1E1208'
              }} data-id="element-404">
                    {tome.title}
                  </span>
                  <span className="block text-xs mt-0.5" style={{
                color: '#9A7B5A'
              }} data-id="element-405">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold rounded-full px-2 py-0.5" style={{
              color: '#7A9E7E',
              backgroundColor: 'rgba(122,158,126,0.08)',
              border: '1px solid rgba(122,158,126,0.25)'
            }} data-id="element-406">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="grid grid-cols-2 gap-2" data-id="element-407">
          {includes.map(item => <div key={item} className="flex items-start gap-2 rounded-lg px-4 py-2.5" style={{
          backgroundColor: 'rgba(255,255,255,0.88)',
          border: '1px solid rgba(200,146,42,0.20)'
        }} data-id="element-408">
              <span className="shrink-0 font-bold text-sm" style={{
            color: '#7A9E7E'
          }} data-id="element-409">
                ✅
              </span>
              <span className="text-xs leading-5" style={{
            color: '#1E1208'
          }} data-id="element-410">
                {item}
              </span>
            </div>)}
        </div>
      </div>

      {/* Degradé inferior → conecta con Bonuses */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FEFAF4 100%)'
    }} data-id="element-411" />
    </section>;
}